import { CssBaseline, Box } from "@mui/material";
export const Loading = () => {
    return (
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                }}
            >
                Loading...
            </Box>
        </>
    );
};
